module.exports = __webpack_public_path__ + "img/示例图.645eda65.png";